import React, { useState } from 'react';
import { Logo } from './Logo';
import { recoverPassword } from '../api/auth.js';

export function LoginView({ onLogin, loading }) {

    const [form, setForm] = useState({ email: '', password: '', rememberMe: false });
    const [error, setError] = useState(null);
    const [recovery, setRecovery] = useState(false);
    const [recoveryEmail, setRecoveryEmail] = useState('');
    const [recoveryDone, setRecoveryDone] = useState(false);
    const [recoveryBusy, setRecoveryBusy] = useState(false);

    const handleRecover = async (event) => {
        event.preventDefault();
        setError(null);
        setRecoveryBusy(true);
        try {
            await recoverPassword(recoveryEmail);
            setRecoveryDone(true);
        } catch (err) {
            setError(err?.response?.data?.error || err?.message || 'Не удалось отправить запрос');
        } finally {
            setRecoveryBusy(false);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);
        try {
            await onLogin(form.email, form.password, form.rememberMe);
        } catch (err) {
            setError(err?.response?.data?.error || err?.message || 'Login failed');
        }
    };

    if (recovery) {
        return (
            <div className='auth'>
                <form className='auth-card' onSubmit={handleRecover}>
                    <div className='auth-logo' style={{ display: 'flex', justifyContent: 'center' }}>
                        <Logo />
                    </div>
                    <p className='auth-subtitle'>Восстановление пароля</p>
                    <label className='auth-label'>
                        Email
                        <input
                            className='auth-input'
                            type='email'
                            required
                            placeholder='you@example.com'
                            value={recoveryEmail}
                            onChange={event => setRecoveryEmail(event.target.value)}
                        />
                    </label>
                    {recoveryDone && <div className='auth-subtitle'>Если такой пользователь есть, мы отправили письмо со ссылкой</div>}
                    {error && <div className='auth-error'>{error}</div>}
                    <button className='auth-button' type='submit' disabled={recoveryBusy}>
                        {recoveryBusy ? 'Отправляем…' : 'Отправить ссылку'}
                    </button>
                    <button className='auth-button' type='button' onClick={() => { setRecovery(false); setRecoveryDone(false); setError(null); }}>
                        Назад ко входу
                    </button>
                </form>
            </div>
        );
    }

    return (
        <div className='auth'>
            <form className='auth-card' onSubmit={handleSubmit}>
                <div className='auth-logo' style={{ display: 'flex', justifyContent: 'center' }}>
                    <Logo />
                </div>
                <p className='auth-subtitle'>Введите учетные данные администратора</p>
                <label className='auth-label'>
                    Email
                    <input
                        className='auth-input'
                        type='email'
                        required
                        placeholder='you@example.com'
                        value={form.email}
                        onChange={event => setForm(prev => ({ ...prev, email: event.target.value }))}
                    />
                </label>
                <label className='auth-label'>
                    Пароль
                    <input
                        className='auth-input'
                        type='password'
                        required
                        placeholder='••••••••'
                        value={form.password}
                        onChange={event => setForm(prev => ({ ...prev, password: event.target.value }))}
                    />
                </label>
                {/* Phase 77 D-18: rememberMe checkbox. Inline style for row layout because
                    .auth-label is column by default and we want checkbox-then-text. We avoid
                    editing the 206KB styles.css per CONTEXT D-18. */}
                <label className='auth-label' style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                    <input
                        type='checkbox'
                        checked={form.rememberMe}
                        onChange={event => setForm(prev => ({ ...prev, rememberMe: event.target.checked }))}
                    />
                    <span>Запомнить меня</span>
                </label>
                {error && <div className='auth-error'>{error}</div>}
                <button className='auth-button' type='submit' disabled={loading}>
                    {loading ? 'Входим…' : 'Войти'}
                </button>
                <button className='auth-button' type='button' onClick={() => { setRecovery(true); setError(null); }}>
                    Забыли пароль?
                </button>
            </form>
        </div>
    );
}
